import * as yup from 'yup';
import { CarePlan1Schema, ICarePlan1 } from './ICarePlanForm1';
import { CarePlan2Schema, ICarePlan2 } from './ICarePlanForm2';
import { CarePlan3Schema, ICarePlan3 } from './ICarePlanForm3';
import { CarePlan4Schema, ICarePlan4 } from './ICarePlanForm4';

export const CarePlanFormSchema = yup.object({
  carePlan1: CarePlan1Schema,
  carePlan2: CarePlan2Schema,
  carePlan3: CarePlan3Schema,
  carePlan4: CarePlan4Schema,
});

export interface ICarePlanForm {
  carePlan1: ICarePlan1;
  carePlan2: ICarePlan2;
  carePlan3: ICarePlan3;
  carePlan4: ICarePlan4;
}
